import { render, staticRenderFns } from "./DSAStudentForm.vue?vue&type=template&id=9b92b08e&scoped=true&"
import script from "./DSAStudentForm.vue?vue&type=script&lang=js&"
export * from "./DSAStudentForm.vue?vue&type=script&lang=js&"
import style0 from "./DSAStudentForm.vue?vue&type=style&index=0&id=9b92b08e&prod&scoped=true&lang=scss&"
import style1 from "./DSAStudentForm.vue?vue&type=style&index=1&id=9b92b08e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b92b08e",
  null
  
)

export default component.exports